import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import 'devextreme-react/text-area';
import ScrollView from 'devextreme-react/scroll-view';
// import Form, { Item, RequiredRule, Label } from 'devextreme-react/form';
import { RadioGroup } from 'devextreme-react/radio-group';
import { Button } from 'devextreme-react/button';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { TextBox } from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import CheckBox from 'devextreme-react/check-box';
import List from 'devextreme-react/list';
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import './new-format-export.scss';

const NewFormatExport = forwardRef((props, ref) => {

    // useImperativeHandle(ref, (e) => ({ exportDataAct }));

    let dataLeft = props.dataHeader

    const [selectedItems, setSelectedItems] = useState([])
    const [selectedItemsRight, setSelectedItemsRight] = useState([])
    const [dataRight, setDataRight] = useState([])
    
    const onSelectedItemsChange = (args) => {
        if(args.name === 'selectedItems') {
            setSelectedItems(args.value)
        }
    }

    const getKeyByValue = (object, value) => {
        return Object.keys(object).find(key => object[key] === value);
    }

    const onSelectedItemsChangeRight = (args) => {
        if(args.name === 'selectedItems') {
            setSelectedItemsRight(args.value)
        }
    }

    const camelCaseToSentence = (name) => {
        let result = name.replace(/([A-Z])/g, " $1");
        let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
        return finalResult
    }

    const itemRender = (item) => {
        return  <div style={{ padding: 0 }}>{camelCaseToSentence(item)}</div>        
    }

    const toRight = () => {
        //console.log('pindah ke kanan')
        //console.log(selectedItems)
        setDataRight(selectedItems)
    }

    const toLeft = async () => {
        console.log(dataRight)

    }

    const onItemClicked = (e) => {
        console.log('item clicked', e.event.itemData)
    }

    return (
        <React.Fragment>
            <ScrollView>
                <ResponsiveBox>
                    <Row />
                    <Row />
                    <Row />
                    <Col ratio={1} />
                    <Col ratio={0.1} />
                    <Col ratio={0.3} />
                    <Col ratio={0.1} />
                    <Col ratio={1} />
                    <Item>
                        <Location row={0} col={0} colspan={5} />
                        <p>To Update this format, make the necessary changes and hit the "Save" button</p>
                    </Item>
                    <Item>
                        <Location row={1} col={0} colspan={3} />
                        <div style={{marginTop: 10}}>
                            <TextBox height="40" stylingMode={"outlined"} placeholder="Export format name..." />
                        </div>
                    </Item>
                    <Item>
                        <Location row={2} col={0} />
                        <div style={{marginTop: 20, borderWidth: 1, borderColor: 'black'}}>
                            <strong>Available fields</strong>
                            <List
                                items={dataLeft}
                                height={350}
                                allowItemDeleting={false}
                                itemDeleteMode={'toggle'}
                                itemRender={itemRender}
                                selectionMode="multiple"
                                selectedItems={selectedItems}
                                onItemClick={onItemClicked}
                                showSelectionControls={true}
                                onOptionChanged={onSelectedItemsChange}>
                            </List>
                        </div>                        
                    </Item>
                    <Item>
                        <Location row={2} col={2} />
                        <ResponsiveBox>
                            <Row />
                            <Row />
                            <Row />
                            <Col />
                            <Item>
                                <Location row={1} col={0} />
                                    <Button onClick={() => toRight()} text="&#8594;" />
                                    <Button onClick={() => toLeft()} style={{marginTop: 20}} text="&#8592;" />
                            </Item>
                        </ResponsiveBox>
                    </Item>
                    <Item>
                        <Location row={2} col={4} />
                        <div style={{marginTop: 20, borderWidth: 1, borderColor: 'black'}}>
                            <strong>Selected fields for export</strong>
                            <List
                                items={dataRight}
                                height={350}
                                allowItemDeleting={false}
                                itemDeleteMode={'toggle'}
                                itemRender={itemRender}
                                selectionMode="multiple"
                                selectedItems={selectedItemsRight}
                                onItemClick={onItemClicked}
                                allowItemDeleting={true}
                                onOptionChanged={onSelectedItemsChangeRight}>
                            </List>
                        </div>                        
                    </Item>                    
                </ResponsiveBox>
            </ScrollView>
        </React.Fragment>
    )

})

export default NewFormatExport;